<template>
  <div class="header-table">
    <div class="cabinet-row" :style="rowStyle">
      <template v-for="roomEntry in roomsWithEmployees" :key="roomEntry.room.id">
        <div
          class="cabinet-cell"
          :style="{
            gridColumn: `span ${roomEntry.employees.length}`,
            width: empColWidth * roomEntry.employees.length + 'px'
          }"
        >
          <span class="cabinet-title">{{ roomEntry.room.name }}</span>
        </div>
      </template>
      <div v-if="scrollbarWidth" class="header-scroll-fake-scrollbar" :style="{ width: scrollbarWidth + 'px' }"></div>
    </div>
    <div class="employee-row" :style="rowStyle">
      <template v-for="roomEntry in roomsWithEmployees" :key="roomEntry.room.id">
        <template v-for="emp in roomEntry.employees" :key="emp.user_id">
          <div class="employee-cell" :style="{ width: empColWidth + 'px' }">
            <div class="employee-content">
              <EmployeeAvatar :name="emp.user_name" :avatar-url="emp.avatar" :size="23" />
              <span class="employee-name" :title="employeeMeta(emp)">{{ employeeMeta(emp) }}</span>
            </div>
          </div>
        </template>
      </template>
      <div v-if="scrollbarWidth" class="header-scroll-fake-scrollbar" :style="{ width: scrollbarWidth + 'px' }"></div>
    </div>
  </div>
</template>

<script>
import EmployeeAvatar from '@/components/util/calendar/EmployeeAvatar.vue'

export default {
  name: 'HeaderCabinetsAndEmployees',
  components: { EmployeeAvatar },
  props: {
    roomsWithEmployees: Array,
    empColWidth: { type: Number, default: 200 },
    scrollbarWidth: { type: Number, default: 16 },
    fallbackEmail: { type: String, default: '' }
  },
  computed: {
    totalEmpCount() {
      return this.roomsWithEmployees.reduce((sum, r) => sum + r.employees.length, 0)
    },
    rowStyle() {
      const colCount = this.totalEmpCount + (this.scrollbarWidth ? 1 : 0)
      return {
        display: 'grid',
        gridTemplateColumns: `repeat(${colCount}, ${this.empColWidth}px)`
      }
    }
  },
  methods: {
    employeeMeta(emp) {
      return emp.user_email || emp.email || this.fallbackEmail || emp.user_name
    }
  }
}
</script>

<style scoped>
.header-scroll-fake-scrollbar {
  background: transparent;
  pointer-events: none;
  height: 100%;
}

.header-table {
  background: transparent;
  user-select: none;
  font-family: var(--ui-font-family-base);
}

.cabinet-row,
.employee-row {
  width: 100%;
}

.cabinet-cell {
  background: var(--cal-surface-header);
  color: var(--cal-text-primary);
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  height: 42px;
  box-sizing: border-box;
  font-size: 20px;
  line-height: 1;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  box-shadow: inset 0 0 0 1px rgba(92, 136, 214, 0.1);
}

.cabinet-title {
  display: block;
  line-height: 1;
  text-align: center;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.employee-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px 0 4px;
  height: 36px;
  box-sizing: border-box;
  background: var(--cal-surface-header);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  box-shadow: inset 0 0 0 1px rgba(92, 136, 214, 0.08);
}

.employee-content {
  display: inline-grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: fit-content;
  min-width: 0;
  max-width: calc(100% - 2px);
  margin: 0 auto;
}

.employee-name {
  min-width: 0;
  font-size: 10px;
  color: var(--cal-text-regular);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
  text-align: center;
  cursor: pointer;
  line-height: 1;
}
</style>
